import { useParams } from 'react-router-dom'

import { RecordGroupDetailLayout } from '@/features/record-groups/components/RecordGroupDetails/RecordGroupDetailLayout'
import { useRecordGroup } from '@/hooks/useRecordGroups'

export function RecordGroupRoute() {
  const { recordGroupId } = useParams<{ recordGroupId: string }>()
  const { data: group } = useRecordGroup(recordGroupId, { keepPreviousData: true })

  return <RecordGroupDetailLayout group={group ?? null} />
}
